/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import {isPastOrTodayIsoDate} from 'utils/formValidation'

export const useBookingSellerReservationPersonSchema = () => {
    const { t } = useTranslation()

    return useMemo(() => z.object({
        name: z.string().trim().min(1, t('First name is required')).max(80),
        last_name: z.string().trim().min(1, t('Last name is required')).max(80),
        email: z.string().trim().email(t('Invalid email')).optional().or(z.literal('')),
        birthdate: z
            .union([
                z.string().trim().min(1, t('Birthdate is required')),
                z.date(),
            ])
            .refine((value) => {
                if (value instanceof Date) {
                    if (Number.isNaN(value.getTime())) return false
                    const tomorrow = new Date()
                    tomorrow.setHours(24, 0, 0, 0)
                    return value < tomorrow
                }

                return isPastOrTodayIsoDate(value)
            }, t('Enter a valid birthdate')),
        packages_cart_item_id: z.number().int().positive(t('Please select a ticket')),
    }), [t])
}

export type BookingSellerReservationPersonInputs = z.infer<ReturnType<typeof useBookingSellerReservationPersonSchema>>
